import React, { useEffect } from 'react';
import adfsAuth from '../../../utils/adfsAuth';

const Redirect = props => {
    useEffect(() => {
        adfsAuth.validateUserSession();
    });

    return <div>
        <div style={{
            fontSize: '20px',
            fontWeight: 'bold'
        }}>En proceso</div>

        <span>Espera por favor...</span>
    </div>;
};

export default Redirect;
